export * from './layout.service';
import { Provider } from '@angular/core';
import { FLOORI_LAYOUTS } from '@floori-web/constants';
import { LayoutService } from './layout.service';

export const layoutProvider: Provider = {
    provide: FLOORI_LAYOUTS,
    useClass: LayoutService,
};
